module.exports = __webpack_public_path__ + "d7b959da55f202b27b8ce7f4dc3cb8ca.pdf";